import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { URL_EXTENSION } from '@utils/constants/app-constants.ts';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const PUT_PARENT_FOLDER_URL = (): string => {
  return `${URL_EXTENSION}/folders/update-parent`;
};

export interface UpdateParentFolderMutationParams {
  ids: string[];
  type: number; // 1 for folder, 3 for document
  parent_id: number | null;
}

export function useUpdateParentFolder() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation(
    async ({ ids, type, parent_id }: UpdateParentFolderMutationParams) => {
      return await Axios.patch(PUT_PARENT_FOLDER_URL(), {
        ids,
        type,
        parent_id
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['folders'] });

        queryClient.invalidateQueries({ queryKey: ['folder'] });
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: (error: any) => {
        let messages: string[] = [];

        if (Array.isArray(error?.response?.data?.detail)) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messages = error.response.data.detail.map((err: any) => {
            const field = err.loc?.[1] ?? 'field';
            return `${field}: ${err.msg}`;
          });
        } else if (error?.response?.data?.message) {
          messages = [error.response.data.message];
        } else {
          messages = [t('an-error-occurred')];
        }

        toast.error(messages.join('\n'));
      },
      useErrorBoundary: false
    }
  );
}
